import { apiV1Client } from "lib/apiClient";
import { ApiResponse } from "types/api";
import { WORKER_OPERATIONS } from "types/operations";
import { CleaningEventListResponse } from "types/response/cleaningEvent";

const workerPath = "/worker";

type ListByDateParams = {
  startDate: Date;
  endDate: Date;
};

/**
 * 担当ビルに紐づく清掃結果一覧を取得
 */
export const callListCleaningEventsByDate = async (input: ListByDateParams) => {
  const res = await apiV1Client.post<ApiResponse<CleaningEventListResponse>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.cleaningEvent.listInCurrentBuilding,
      data: {
        startDate: input.startDate.toISOString(),
        endDate: input.endDate.toISOString(),
      },
    }
  );
  return res.data.data;
};

type ListByRobot = {
  robotId: string;
};
/**
 * ロボットに紐づく清掃結果一覧を取得
 */
export const callListCleaningEventsByRobot = async (input: ListByRobot) => {
  const res = await apiV1Client.post<ApiResponse<CleaningEventListResponse>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.cleaningEvent.listInRobot,
      data: {
        robotId: input.robotId,
      },
    }
  );
  return res.data.data;
};

type ListByMapParams = {
  mapId: string;
};
/**
 * マップに紐づく清掃結果一覧を取得
 */
export const callListCleaningEventsByMap = async (input: ListByMapParams) => {
  const res = await apiV1Client.post<ApiResponse<CleaningEventListResponse>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.cleaningEvent.listInMap,
      data: {
        mapId: input.mapId,
      },
    }
  );
  return res.data.data;
};

type UpdateStatusParams = {
  cleaningId: string;
  status: string;
};

/**
 * 清掃結果の手動清掃結果を更新する
 */
export const callUpdateCleaningEventStatus = async (
  input: UpdateStatusParams
) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.cleaningEvent.updateStatus,
    data: {
      cleaningEventId: input.cleaningId,
      status: input.status,
    },
  });
};

/**
 * 担当ビルに関連する清掃結果を外部サービスと同期を行う
 */
export const callSyncCleaningEvent = async () => {
  await apiV1Client.post<ApiResponse<null>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.cleaningEvent.syncInCurrentBuilding,
    },
    {
      timeout: 60_000,
    }
  );
};
